<!-- ================管理端-读书会====================-->
<template>
    <div class="admin-screen-container">
        <div class="admin-title-container">主题活动列表</div>
        <div class="admin-btn-container">
            <div class="admin-btn-item" @click="handleCreate">创建主题活动</div>
        </div>
        <div class="admin-search4-100">
            <div class="admin-search25">
                <div class="admin-search25-name">所属五馆:</div>
                <div class="admin-search25-item">
                    <el-select clearable @change="changeMuseum"
                               v-model="queryParams.museumKey" placeholder="请选择">
                        <el-option v-for="item in museumList" :key="item.dictKey" :label="item.dictValue"
                                   :value="item.dictKey" />
                    </el-select>
                </div>
            </div>
            <div class="admin-search25">
                <div class="admin-search25-name">所属主题:</div>
                <div class="admin-search25-item">
                    <el-select clearable @change="pageList(null)"
                               v-model="queryParams.activityItem" placeholder="请选择">
                        <el-option v-for="item in itemList" :key="item.itemId" :label="item.itemMonth+' '+item.itemName"
                                   :value="item.itemId" />
                    </el-select>
                </div>
            </div>
            <div class="admin-search25">
                <div class="admin-search25-name">所属学段:</div>
                <div class="admin-search25-item">
                    <el-select clearable @change="pageList(null)"
                               v-model="queryParams.periodKey" placeholder="请选择">
                        <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                   :value="item.dictKey" />
                    </el-select>
                </div>
            </div>
            <div class="admin-search25">
                <div class="admin-search25-name">年级段:</div>
                <div class="admin-search25-item">
                    <el-select clearable @change="pageList(null)"
                               v-model="queryParams.activityGrade" placeholder="请选择">
                        <el-option v-for="item in itemGradeList" :key="item.dictKey" :label="item.dictValue"
                                   :value="item.dictKey" />
                    </el-select>
                </div>
            </div>
        </div>
        <div class="admin-search4-100">
            <div class="admin-search25">
                <div class="admin-search25-name" v-if="this.queryParams.museumKey==='4'">四季主题:</div>
                <div class="admin-search25-item" v-if="this.queryParams.museumKey==='4'">
                    <el-select clearable @change="pageList(null)"
                               v-model="queryParams.seasonItem" placeholder="请选择">
                        <el-option v-for="item in seasonItemList" :key="item.itemId" :label="item.itemMonth+' '+item.itemName"
                                   :value="item.itemId" />
                    </el-select>
                </div>
            </div>
            <div class="admin-search25"></div>
            <div class="admin-search25"></div>
            <div class="admin-search25">
                <div class="admin-search25-item-input">
                    <el-input class="admin-input1" v-model="queryParams.activityName" placeholder="请输入主题活动名称" >
                        <template #append>
                            <el-button @click="handleQuery" class="name-search-btn"
                                       type="primary" icon="el-icon-search" />
                        </template>
                    </el-input>
                </div>
            </div>
        </div>
        <!--数据列表-->
        <div class="mt5">
            <el-table v-loading="loading"
                      cell-class-name="admin-table"
                      show-overflow-tooltip
                      height="calc(100vh - 300px)"
                      :data="dataList"
                      class="admin-table"
                      highlight-current-row>
                <el-table-column type="index"  fixed="left" align="center" label="序号" width="60" />
                <el-table-column label="活动名称" align="center" prop="activityName" width="200" >
                    <template #default="scope">
                        <div :title="scope.row.activityName" @click="handleDetail(scope.row)" style="color: #377f7f;"
                             class="text-one cursor">
                            {{ scope.row.activityName }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="240" label="活动说明" align="center" prop="activityDesc">
                    <template #default="scope">
                        <div :title="stripHtml(scope.row.activityDesc)" class="text-one">
                            {{ stripHtml(scope.row.activityDesc) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="200" label="活动主题" align="center" prop="activityItemName" />
                <el-table-column width="240" label="活动目标" align="center" prop="activityAim">
                    <template #default="scope">
                        <div :title="stripHtml(scope.row.activityAim)" class="text-one">
                            {{ stripHtml(scope.row.activityAim) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="120" label="学段·年级段" align="center" prop="activityItemName">
                    <template #default="scope">
                        <div :title="scope.row.periodName+''+scope.row.activityGradeName" class="text-one cursor">
                            {{ scope.row.periodName }} {{ scope.row.activityGradeName?'| '+scope.row.activityGradeName: ''}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="120" label="所属五馆" align="center" prop="museumName">
                    <template #default="scope">
                        <div :title="scope.row.museumName"
                             class="text-one cursor">
                            {{ scope.row.museumName }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="100" fixed="right"  align="center" label="操作"
                                 class-name="small-padding fixed-width">
                    <template #default="scope">
                        <el-popover placement="bottom" trigger="click"
                                    :width="80" popper-style="padding: 5px 0 0">
                            <template #reference>
                                <el-button type="primary" size="default">操作</el-button>
                            </template>
                            <template #default>
                                <div>
                                    <div class="text-item">
                                        <el-text type="primary" @click="handleDetail(scope.row)">查看</el-text>
                                    </div>
                                    <div class="text-item">
                                        <el-text type="primary" @click="handleUpdate(scope.row)">编辑</el-text>
                                    </div>
                                    <div class="text-item">
                                        <el-popconfirm
                                          confirm-button-text="是"
                                          cancel-button-text="否"
                                          icon-color="#626AEF"
                                          title="确定删除?"
                                          @confirm="handleDelete(scope.row)">
                                            <template #reference>
                                                <el-text type="danger">删除</el-text>
                                            </template>
                                        </el-popconfirm>
                                    </div>

                                </div>
                            </template>
                        </el-popover>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--  分页  -->
        <div>
            <pagination :background="false"
                        :pageSizes="[10, 20, 30]"
                        :total="total"
                        v-model:page.sync="queryParams.pageNum"
                        v-model:limit.sync="queryParams.pageSize"
                        @pagination="pageList" />
        </div>
    </div>

</template>
<script>
import {deleteMuseumActivity, pageMuseumActivity} from "@/api/admin/museumActivity";
import {queryDict} from "@/api/admin/dict";
import {listItem} from "@/api/admin/item";
import {timestampDate, timestampToTime} from "@/utils/date";
import {charConversion} from "@/utils/str";

export default {
    components: {},
    name: "museumActivityIndex",
    data() {
        return {
            timestampToTime,
            timestampDate,
            loading: false,
            /*分页查询读书会*/
            queryParams:{
                activityName:'',
                activityItem:'',
                seasonItem:'',
                periodKey:'',
                museumKey:'',
                activityGrade:'',
                pageNum: 1,
                pageSize: 10,
            },
            dataList:[],
            total:0,
            periodList:[],
            itemGradeList:'',
            queryItemParams:{
                itemType:1,
                museumKey:'1',
            },
            itemList:[],
            seasonItemList:[],
            museumList:[],
        }
    },
    computed: {},
    watch: {},
    created() {
        this.pageList();
        this.handleQueryDict();
        this.handleQuerySeasonItem();
    },
    mounted() {},
    methods: {
        /*===========数据查询============*/
        stripHtml(html){
            return charConversion((html || '').replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').trim());
        },
        changeMuseum(){
            this.queryParams.activityItem = ''
            this.queryParams.seasonItem = ''
            this.pageList(null);
            if (this.queryParams.museumKey){
                this.handleMuseumItem();
            }
        },
        handleMuseumItem(){
            this.queryItemParams.museumKey = this.queryParams.museumKey;
            //阅读拓展馆
            if (this.queryParams.museumKey === '1'){
                this.queryItemParams.itemType = 1;
            }
            //科技艺术馆
            if (this.queryParams.museumKey === '2'){
                this.queryItemParams.itemType = 2;
            }
            //非遗文化馆
            if (this.queryParams.museumKey === '3'){
                this.queryItemParams.itemType = 3;
            }
            //劳动实践馆
            if (this.queryParams.museumKey === '4'){
                this.queryItemParams.itemType = 5;
            }
            //自然研学馆
            if (this.queryParams.museumKey === '5'){
                this.queryItemParams.itemType = 6;
            }
            this.handleQueryItem();
        },
        handleQueryDict() {
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                if (res.data.code === 1) {
                    this.periodList = res.data.data;
                }
            })
            queryDict({ code: 'grade_period' }).then(res => {
                if (res.data.code === 1) {
                    this.itemGradeList = res.data.data;
                }
            })
            queryDict({ code: 'museum_info' }).then(res => {
                if (res.data.code === 1) {
                    this.museumList = res.data.data;
                }
            })
        },
        handleQueryItem(){
            listItem(this.queryItemParams).then(res => {
                if (res.data.code === 1) {
                    this.itemList = res.data.data;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        handleQuerySeasonItem(){
            this.queryItemParams.itemType = 4;
            this.queryItemParams.museumKey = "4"
            listItem(this.queryItemParams).then(res => {
                if (res.data.code === 1) {
                    this.seasonItemList = res.data.data;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        handleQuery(){
            this.pageList(null);
        },
        pageList(e){
            this.loading = true
            this.dataList = [];
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            pageMuseumActivity(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.total = res.data.data.total;
                    this.dataList = JSON.parse(JSON.stringify(res.data.data.list));
                    this.loading = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading = false;
                }
            })
        },
        handleDelete(row){
            deleteMuseumActivity({ activityId: row.activityId }).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功");
                    this.pageList(null);
                } else {
                    this.$message.error("操作失败");
                }
            })
        },
        handleCreate(){
            this.$router.push({
                path: "/museumActivityCreate",
            });
        },
        handleUpdate(row){
            this.$router.push({
                path: "/museumActivityCreate",
                query: {
                    activityId: row.activityId,
                }
            });
        },
        handleDetail(row){
            this.$router.push({
                path: "/museumActivityDetail",
                query: {
                    activityId: row.activityId,
                }
            });
        },
    },
}
</script>
<style scoped>
.admin-select1{
    width: 90px;
}
.admin-select1 /deep/ .el-select__wrapper {
    height: 30px; /* 高度 */
    line-height: 28px;
    min-height: 30px!important;
}
.admin-input1 /deep/ .el-input__wrapper {
    height: 30px; /* 高度 */
    line-height: 28px;
    min-height: 30px!important;
}
.name-search-btn{
    background-color: #377f7f!important;
    color: #fff!important;
}

</style>
